export const TYPE_PRODUCTS = 1;
export const TYPE_BLOCKS = 2;
export const TYPE_CRM = 3;
export const TYPE_MEDIA = 4;

export const STATUS_NEW = 0;
export const STATUS_OPENED = 1;
export const STATUS_START_TESTING = 2;
export const STATUS_TEST_PASSED = 3;
export const STATUS_TEST_FAILED = 4;
export const STATUS_TEST_RETRY_FAILED = 4;